import { X } from "lucide-react";
import axios from "axios";
import { signInWithEmailAndPassword, signInWithPopup } from "firebase/auth";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { styled } from "styled-components";
import AuthButton from "../../components/auth/AuthButton";
import { closeModal, openModal } from "../../redux/modalSlice";
import { loginFailure, loginStart, loginSuccess } from "../../redux/userSlice";
import { auth, provider } from "../../utils/firebase";
import LogoPNG from "../../utils/img/logo.png";
import { usePostHog } from "@posthog/react";
const Container = styled.div`
  //Layout
  align-items: center;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  flex-basis: auto;
  flex-direction: column;
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
`;
const Wrapper = styled.div`
  //Layout
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  position: relative;
  overflow: hidden;
  //Appearance
  min-width: 600px;
  max-width: 80vw;
  min-height: 400px;
  max-height: 90vh;
  background-color: ${({ theme }) => theme.colorBackground};
  color: ${({ theme }) => theme.colorOnBackground};
  border-radius: 12px;
`;
const BackDrop = styled.div`
  //Layout
  align-items: stretch;
  box-sizing: border-box;
  display: flex;
  flex-basis: auto;
  flex-direction: column;
  flex-shrink: 0;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0;
  margin: 0px;
  padding: 0px;
  z-index: 0;
  position: fixed;
  //Appearance
  background-color: #000000a7;
  color: ${({ theme }) => theme.colorOnBackground};
`;
const ModalHead = styled.div`
  //Layout
  flex-shrink: 0;
  flex-grow: 0;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  padding: 16px;
  border-bottom: 1px solid ${({ theme }) => theme.colorSurface};
  cursor: default;
`;
const ModalBody = styled.div`
  //Layout
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  align-self: stretch;
  max-width: 600px;
  overflow: auto;
`;

const CloseButton = styled.button`
  flex: none;
  height: 32px;
  width: 32px;
  border: none;
  background-color: rgba(0, 0, 0, 0);
  color: ${({ theme }) => theme.colorOnBackground};
  border-radius: 24px;
  font-weight: 500;
  cursor: pointer;
  flex-shrink: 0;
  order: 1;
  &:hover {
    background-color: ${({ theme }) => theme.colorOnSurfaceVariant};
    background-color: ${({ theme }) => theme.colorSurfaceVariant};
  }
`;
const Hr = styled.hr`
  margin: 15px 0;
  border: 0.5px solid ${({ theme }) => theme.colorSurfaceVariant};
  flex: 1;
`;
const Or = styled.p`
  margin: 0px;
  padding: 0px;
  flex: 0;
  color: ${({ theme }) => theme.colorOnSurfaceVariant};
`;
const Divider = styled.div`
  //Layout
  align-items: center;
  box-sizing: border-box;
  display: flex;
  gap: 12px;
  flex-basis: auto;
  flex-shrink: 0;
  width: 100%;
  max-width: 284px;
  min-width 240px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  //Flex
  order: 1;
  //Typography
  font-size: 16px;
  line-height: 24px;
  //Appearance
  color: ${({ theme }) => theme.colorOnBackground};
  cursor: default;
`;
const FormContainer = styled.div`
  //Layout
  align-items: stretch;
  box-sizing: border-box;
  display: flex;
  gap: 20px;
  flex-basis: auto;
  flex-direction: column;
  flex-shrink: 0;
  width: 100%;
  max-width: 284px;
  min-width 240px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  //Flex
  order: 1;
  //Typography
  font-size: 16px;
  line-height: 24px;
  //Appearance
  color: ${({ theme }) => theme.colorOnBackground};
  cursor: default;
`;
const ButtonContainer = styled.div`
  //Layout
  align-items: stretch;
  box-sizing: border-box;
  display: flex;
  gap: 12px;
  flex-basis: auto;
  flex-direction: column;
  flex-shrink: 0;
  width: 100%;
  max-width: 284px;
  min-width 240px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  //Flex
  order: 1;
  //Typography
  font-size: 16px;
  line-height: 24px;
  //Appearance
  color: ${({ theme }) => theme.colorOnBackground};
  cursor: default;
`;
const SignInContainer = styled.div`
  //Layout
  align-items: stretch;
  box-sizing: border-box;
  display: flex;
  gap: 12px;
  flex-basis: auto;
  flex-direction: column;
  flex-shrink: 0;
  width: 100%;
  max-width: 284px;
  min-width 240px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  margin-top: 24px;
  //Flex
  order: 1;
  //Typography
  font-size: 16px;
  line-height: 24px;
  //Appearance
  color: ${({ theme }) => theme.colorOnBackground};
  cursor: default;
`;
const SignInText = styled.p`
  //Layout
  margin: 0px;
  //Flex
  order: 1;
  //Typography
  font-size: 16px;
  line-height: 18px;
  //Appearance
  color: ${({ theme }) => theme.colorOnBackground};
  cursor: default;
`;
const SignInLink = styled.a`
  //Layout
  //Flex
  order: 1;
  //Typography
  font-size: 16px;
  line-height: 18px;
  //Appearance
  color: ${({ theme }) => theme.colorSecondary};
  cursor: pointer;
`;
const Form = styled.form`
  //Layout
  align.items: stretch;
  box-sizing: border-box;
  display: flex;
  flex-basis: auto;
  flex-direction: column;
  flex-shrink: 0;
  width: 100%;
  //Flex
  order: 1;
  gap: 12px;
  //Typography
  font-size: 16px;
  line-height: 24px;
  //Appearance
  color: ${({ theme }) => theme.colorOnBackground};
  cursor: default;
`;
const Input = styled.input`
  border: 1px solid ${({ theme }) => theme.colorOutline};
  border-radius: 8px;
  padding: 10px;
  background-color: ${({ theme }) => theme.colorBackground};
  color: ${({ theme }) => theme.colorOnBackground};
  font-size: 17px;
  font-weight: 400;
`;
const Button = styled.button`
  margin-top: 8px;
  padding: 5px;
  background-color: ${({ theme }) => theme.colorTertiary};
  padding: 8px 12px;
  color: ${({ theme }) => theme.colorOnTertiary};
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid green;
  &:hover {
    color: ${({ theme }) => theme.colorOnTertiaryContainer};
    background-color: ${({ theme }) => theme.colorTertiaryContainer};
  }
`;
const ButtonDisabled = styled.button`
  margin-top: 8px;
  padding: 5px;
  background-color: darkseagreen;
  color: white;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  cursor: not-allowed;
  border: 1px solid green;
  &:hover {
    background-color: lightgreen;
  }
`;
const BodyContainer = styled.div`
  //Layout
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  flex: 1 0 0;
  align-self: stretch;
  //Typography
  font-size: 15px;
  line-height: 20px;
  //Appearance
  color: ${({ theme }) => theme.colorOnBackground};
  background-color: ${({ theme }) => theme.colorBackground};
  border: 2px solid background-color: ${({ theme }) => theme.colorBackground};
  border-radius: 12px;
  cursor: default;
`;
const BodyWrapper = styled.div`
  //Layout
  align-items: center;
  display: flex;
  flex-direction: column;
  flex: 1 0 0;
  align-self: stretch;
  padding-top: 24px;
  padding-bottom: 48px;
  gap: 18px;
  //Typography
  font-size: 15px;
  line-height: 20px;
  //Appearance
  color: ${({ theme }) => theme.colorOnBackground};
`;
const Img = styled.img``;

const H2 = styled.h2`
  //Layout
  box-sizing: border-box;
  display: block;
  margin: 0px;
  //Typography
  font-size: 31px;
  font-weight: 700;
  letter-spacing: -1.2px;
  line-height: 36px;
  text-align: center;
  white-space: pre-line;
  word-break: break-word;
  //Appearance
  color: ${({ theme }) => theme.colorOnBackground};
  cursor: default;
`;

const Logo = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  order: 2;
  width: 100%;
  justify-content: space-evenly;
  padding-right: 52px;
`;
const TextContainer = styled.div`
  //Layout
  align-items: stretch;
  box-sizing: border-box;
  display: flex;
  gap: 12px;
  flex-basis: auto;
  flex-direction: column;
  flex-shrink: 0;
  width: 100%;
  max-width: 284px;
  min-width 240px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  //Flex
  order: 1;
  //Typography
  font-size: 13px;
  line-height: 16px;
  //Appearance
  color: ${({ theme }) => theme.colorOnBackground};
  cursor: default;
`;
const TextLink = styled.a`
  //Layout
  margin: 0px;
  //Flex
  order: 1;
  //Typography
  font-size: 13px;
  line-height: 16px;
  //Appearance
  color: ${({ theme }) => theme.colorSecondary};
  cursor: pointer;
`;
const SignInModal = () => {
  const [signInEmail, setSignInEmail] = useState("");
  const [signInPassword, setSignInPassword] = useState("");
  const dispatch = useDispatch();
  const posthog = usePostHog();
  const handleSignin = async (e) => {
    e.preventDefault();
    dispatch(loginStart());
    signInWithEmailAndPassword(auth, signInEmail, signInPassword)
      .then((userCredential) => {
        // Signed in
        console.log("signed in");
        axios
          .post(
            `${process.env.REACT_APP_RECIPE_API_BASE_URL}/auth/signin`,
            {
              email: signInEmail,
              password: signInPassword,
            },
            { withCredentials: true },
          )
          .then((res) => {
            dispatch(loginSuccess(res.data));
            posthog?.identify(res.data._id, { email: res.data.email, name: res.data.name });
            posthog?.capture("user_signed_in", { method: "email" });
            dispatch(closeModal());
          });
        //navigate("/");
        // ...
      })
      .catch((error) => {
        console.log("error in");
        dispatch(loginFailure());
        posthog?.captureException(error, { method: "email" });
        const errorCode = error.code;
        const errorMessage = error.message;
        console.log(errorCode, errorMessage);
      });
  };
  const signInWithGoogle = async () => {
    signInWithPopup(auth, provider)
      .then((result) => {
        axios
          .post(`${process.env.REACT_APP_RECIPE_API_BASE_URL}/auth/google`, {
            name: result.user.displayName,
            email: result.user.email,
            nickname: result.user.email,
            img: result.user.photoURL,
          })
          .then((res) => {
            dispatch(loginSuccess(res.data));
            posthog?.identify(res.data._id, { email: res.data.email, name: res.data.name });
            posthog?.capture("user_signed_in", { method: "google" });
            dispatch(closeModal());
          });
      })
      .catch((error) => {
        console.log("error: " + error);
        posthog?.captureException(error, { method: "google" });
      })
      .then(dispatch(closeModal()));
  };

  const closeSignUpModal = (e) => {
    e.preventDefault();
    dispatch(closeModal());
  };
  const handleOpenSignUpModal = (e) => {
    e.preventDefault();
    dispatch(openModal("SignUp"));
  };
  const handleResetPassword = (e) => {
    e.preventDefault();
    dispatch(openModal("ResetPassword"));
  };
  return (
    <Container>
      <BackDrop onClick={closeSignUpModal} />
      <Wrapper>
        <ModalHead>
          <CloseButton onClick={closeSignUpModal}>
            <X size={20} />
          </CloseButton>
          <Logo>
            <Img src={LogoPNG} />
          </Logo>
        </ModalHead>
        <ModalBody>
          <BodyContainer>
            <BodyWrapper>
              <H2>Sign in</H2>
              <ButtonContainer>
                <AuthButton
                  click={signInWithGoogle}
                  text="Sign in with Google"
                />
              </ButtonContainer>
              <Divider>
                <Hr />
                <Or>or</Or>
                <Hr />
              </Divider>
              <FormContainer>
                <Form>
                  <Input
                    placeholder="Email"
                    onChange={(e) => setSignInEmail(e.target.value)}
                  ></Input>
                  <Input
                    type="password"
                    placeholder="Password"
                    onChange={(e) => setSignInPassword(e.target.value)}
                  ></Input>
                  {signInEmail && signInPassword ? (
                    <Button type="submit" onClick={handleSignin}>
                      Sign in
                    </Button>
                  ) : (
                    <ButtonDisabled>Sign in</ButtonDisabled>
                  )}
                </Form>
              </FormContainer>
              <TextContainer>
                <TextLink onClick={handleResetPassword}>
                  Reset Password
                </TextLink>
              </TextContainer>
              <SignInContainer>
                <SignInText>
                  No account yet?{" "}
                  <SignInLink onClick={handleOpenSignUpModal}>
                    Sign up today!
                  </SignInLink>
                </SignInText>
              </SignInContainer>
            </BodyWrapper>
          </BodyContainer>
        </ModalBody>
      </Wrapper>
    </Container>
  );
};
export default SignInModal;
